import { AppThunk } from 'store/globalTypes';
import { useGetSubscription } from 'store/subscription/actions';

import { HIDE_SUBSCRIPTION_MODAL, SHOW_SUBSCRIPTION_MODAL } from './actionsTypes';

// Показать модальное окно подписки
export const showSubscriptionModal = () => {
  return {
    type: SHOW_SUBSCRIPTION_MODAL,
  };
};

// Скрыть модальное окно подписки
export const hideSubscriptionModal = () => ({
  type: HIDE_SUBSCRIPTION_MODAL,
});

// Пример асинхронного экшена для открытия модального окна подписки
export const openSubscriptionModalIfPastDue: AppThunk =
  (callback: () => void) => (dispatch) => {
    const { data: subscription } = useGetSubscription();
    const activeSubscription = subscription?.subscriptions.find(
      (sub) => sub.product_type.toLowerCase() === 'menu',
    );

    if (
      activeSubscription?.status === 'Cancel' ||
      activeSubscription?.status === 'InActive'
    ) {
      dispatch(showSubscriptionModal());
    } else {
      callback();
    }
  };
